import './index.css';
import 'ol/ol.css';

import mapConfig from '../map.config';

import Map from 'ol/Map';
import View from 'ol/View';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import {getDefaultStyle, getStyle} from "./constants/style.constant";
import {Control, defaults as defaultControls} from "ol/control";
import {getData} from "./functions/utils.functions";
import {getContrastColor, mixColors} from "./functions/colors.functions";
import Overlay from "ol/Overlay";
// import {default as jenks} from 'turf-jenks';
import {provinceLayer} from './layers/province.layer';
import {comuniLayer, getComuniHlStyle} from './layers/comuni.layer';
import Style from "ol/style/Style";
import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";

const GeoStats = require('geostats/lib/geostats');
const comuniList = {}; /// Elenco di tutti i comuni in base al codice ISTAT


let colorPalette = [
    '#deecf8',
    '#e5d4c9',
    '#edbc9a',
    '#f5a46b',
    '#fd8d3c'
];
/**
 * Una volta renderizzato il layer delle province centra la mappa
 */
provinceLayer.once('postrender', function () {
    centerFullMap();
});

const confrontoExplanation = document.getElementById('confronto-explanation');
/**
 * Una volta renderizzato il layer dei comuni conserva un riferimento a ogni comune in una mappa chiave: valore
 */
comuniLayer.once('postrender', function () {
    comuniLayer.getSource().forEachFeature((feature) => {
        // TODO VERIFICARE CHE SIA IL CODICE ISTAT CORRETTO (ABBIAMO DUE TIPI UNO ESTESO E UNO BREVE)
        comuniList[feature.values_.istat_brev] = feature;
    });
});

/**
 * Registra un custom control per mostrare i colori
 */
const ColorLegendControl = /*@__PURE__*/(function (Control) {
    function ColorLegendControl(opt_options) {
        let options = opt_options || {};
        const size = 40;

        let element = document.createElement('div');
        element.className = 'color-legend ol-unselectable ol-control';

        this.colors = colorPalette;
        this.steps = [0, 20, 40, 60, 80];

        this.setColors = function (colors) {
            this.colors = colors;
        }
        this.setSteps = function (steps) {
            this.steps = steps;
        }
        this.hide = function () {
            element.style.display = 'none';
        }
        this.show = function () {
            element.style.display = 'block';
        }
       this.draw = () => {
         const size = 40;
         const legendContainer = document.createElement("div");

         // Container style for vertical layout
         legendContainer.style.display = "flex";
         legendContainer.style.flexDirection = "column";
         legendContainer.style.alignItems = "flex-start";
         legendContainer.style.gap = "4px";

         // Draw color boxes with aligned labels
         for (let i = 0; i < this.colors.length; i++) {
           const rowContainer = document.createElement("div");
           rowContainer.style.display = "flex";
           rowContainer.style.alignItems = "center";
           rowContainer.style.gap = "8px";
           
           const colorBox = document.createElement("div");
           colorBox.style.backgroundColor = this.colors[i];
           colorBox.style.width = size + "px";
           colorBox.style.height = "20px";
           colorBox.style.border = "1px solid #ccc";
           
           const label = document.createElement("div");
           label.style.fontSize = "12px";
           label.style.lineHeight = "20px";
           label.style.height = "20px";
           label.style.display = "flex";
           label.style.alignItems = "center";
           
           if (i < this.steps.length) {
               label.innerText = String(this.steps[i]);
           }
           
           rowContainer.appendChild(colorBox);
           rowContainer.appendChild(label);
           legendContainer.appendChild(rowContainer);
         }
    
         element.innerHTML = "";
         element.appendChild(legendContainer);
        };

        Control.call(
            this,
            {
                element: element,
                target: options.target
            }
        );

        this.draw();
    }

    if (Control) ColorLegendControl.__proto__ = Control;
    ColorLegendControl.prototype = Object.create(Control && Control.prototype);
    ColorLegendControl.prototype.constructor = ColorLegendControl;

    return ColorLegendControl;
}(Control));

/**
 * Crea il markup HTML per il popup
 * @return {HTMLDivElement}
 */
const popupContainer = document.createElement('div');
popupContainer.setAttribute('id', 'popup');
popupContainer.setAttribute('class', 'ol-popup');
const popupClose = document.createElement('a');
popupClose.setAttribute('href', 'javascript:;');
popupClose.setAttribute('class', 'ol-popup-closer');
const popupContent = document.createElement('div');
popupContent.setAttribute('id', 'popup-content');
popupContainer.appendChild(popupClose);
popupContainer.appendChild(popupContent);

popupClose.onclick = function () {
    destroyOverlay();
    popupClose.blur();
    return false;
};

const centerFullMap = () => {
    const layerExtent = provinceLayer.getSource().getExtent();
    if (layerExtent) {
        map.getView().fit(layerExtent, {duration: 500});
    }
}

const destroyOverlay = () => {
    /// do something
    map.removeOverlay(map.getOverlayById('infoOverlay'));
    const mobileOverlay = document.getElementById('mobile-overlay');
    popupClose.onclick = destroyOverlay;
    if (!!mobileOverlay) {
        mobileOverlay.parentNode.removeChild(mobileOverlay);
    }
}
/**
 * Inizializza la mappa
 * @type {*|Map}
 */
const ColorLegendItem = new ColorLegendControl();
const map = new Map({
    controls: defaultControls({
        zoom: false
    }).extend([
        ColorLegendItem
    ]),
    layers: [
        comuniLayer,
        provinceLayer,
    ],
    target: 'map',
    view: new View({
        center: mapConfig.center,
        zoom: mapConfig.zoom,
        minZoom: mapConfig.minZoom,
        maxZoom: mapConfig.maxZoom
    })
});
/**
 * Inizializza il sorgente per il layer di overlay dei comuni
 * @type {*|VectorSource}
 */
const comuniOverlayLayerSource = new VectorSource();
/**
 * Inizializza il layer di highlight che conterrà le forme colorate dei comuni all'hover del mouse
 */
new VectorLayer({
    source: comuniOverlayLayerSource,
    name: 'comuni_highlight',
    map: map
});

/**
 * Evidenzia la provincia e il comune, usato onPointerMove e onClick
 */
const enhanceProvinciaComune = (evt) => {
    if (evt.dragging) {
        return;
    }

    !!comuneFeature && comuniOverlayLayerSource.removeFeature(comuneFeature);
    comuneFeature = false;

    const pixel = map.getEventPixel(evt.originalEvent);

    map.forEachFeatureAtPixel(pixel, (feature, layer) => {
        if (!layer || !feature || !!comuneFeature) {
            return;
        }
        const LayerName = layer.get('name');
        if (LayerName === 'comuni') {
            comuneFeature = feature.clone();
            comuneFeature.setStyle(getComuniHlStyle);
        }
    });

    provinceLayer.getSource().forEachFeature((provinciaFeature) => {
        if (!!comuneFeature && comuneFeature.values_.provincia === provinciaFeature.values_.provincia) {
            provinciaFeature.setStyle(new Style({}));
        } else {
            provinciaFeature.setStyle(null);
        }
    });
    if (!!comuneFeature) {
        /**
         * Mostra nasconde le province che toccano il mouse
         */
        comuniOverlayLayerSource.addFeature(comuneFeature);
    }
};
/**
 * Attiva la callback al mousemove sulla mappa per evidenziare provincia e comune
 */
let comuneFeature;
map.on('pointermove', enhanceProvinciaComune);

map.on("click", function (evt) {
    destroyOverlay();
    const Coordinates = evt.coordinate;

    map.forEachFeatureAtPixel(evt.pixel, function (feature, layer) {
        if (!layer || !feature) {
            return;
        }
        const LayerName = layer.get('name');
        if (LayerName === 'comuni') {
            if (!feature.values_.hasOwnProperty('value')) {
                /// Ho fatto click su una zona che non contiene nessun valore
                return;
            }
            popupContainer.style.backgroundColor = feature.style_.fill_.color_;
            popupContainer.style.color = getContrastColor(feature.style_.fill_.color_, true);
            popupContent.innerHTML = `<h3>${feature.values_.nome}</h3>  <p>${feature.values_.value}</p>${!!feature.values_.sezioni ? '<small>Sezioni: ' + feature.values_.sezioni + '</small>' : ''}`;

            enhanceProvinciaComune(evt);


            if (isSmallScreen()) {
                /**
                 * Centro la mappa sul comune selezionato.
                 */
                const layerExtent = feature.getGeometry().getExtent();
                if (layerExtent) {
                    map.getView().fit(layerExtent, {duration: 1000});
                }
                const popup = popupContainer.cloneNode(true);
                popup.addEventListener('click', () => {
                    destroyOverlay();
                    centerFullMap();
                });
                popup.style.display = 'block';
                popup.setAttribute('id', 'mobile-overlay');
                document.body.appendChild(popup);
            } else {
                /**
                 * Crea un overlay ancorato alla mappa (per mostrare popup)
                 * @type {Overlay|*|Overlay}
                 */
                const overlay = new Overlay({
                    element: popupContainer,
                    id: 'infoOverlay',
                    autoPan: true,
                    autoPanAnimation: {
                        duration: 250
                    }
                });
                destroyOverlay();
                map.addOverlay(overlay);
                overlay.setPosition(Coordinates);
            }
        }
    })
});

/**
 * Restituisce un array di colori
 * @param color1 {string}
 * @param color2 {string}
 * @param stepNum {number}
 */

function getColorGradient(color1, color2, stepNum) {
    const stepSize = 100 / (stepNum - 1);
    const result = [];
    for (let i = 0; i < stepNum; i++) {
        result.push(mixColors(color1, color2, stepSize * i));
    }
    return result;
}

function getStepsFromGeoStats(data, steps) {
    try {
        const filteredData = data.filter(num => !isNaN(num) && num !== null && num !== undefined);
        
        // Check if we have enough valid data
        if (filteredData.length < steps) {
            console.warn('Not enough data points for Jenks classification, using default steps');
            return [0, 20, 40, 60, 80];
        }
        
        const gs = new GeoStats(filteredData);
        const jenksResult = gs.getJenks(steps);
        
        // Validate the result
        if (!jenksResult || jenksResult.length !== steps + 1) {
            console.warn('Invalid Jenks result, using default steps');
            return [0, 20, 40, 60, 80];
        }
        
        return jenksResult;
    } catch (error) {
        console.error('Error in getStepsFromGeoStats:', error);
        console.log('Falling back to default steps');
        return [0, 20, 40, 60, 80];
    }
}

const year2020Data = {};

function loadWinnerMapData(winnerMapData) {
    document.getElementById('loader_overlay').style.display = 'block';
    document.getElementById('map-title').textContent = winnerMapData.title;
    if (winnerMapData.url) {
        // Load data from file
        getData(winnerMapData.url, (response) => {
            const transformedData = {};
            if (!response || !response[0] || !response[0].dati || response[0].dati.length === 0) {
                resetToInitialState();
                return;
            }
            if (response && response[0].dati) {
                response[0].dati
                    .filter(item => item.istatComune !== null && item.istatComune !== undefined)
                    .forEach(item => {
                        transformedData[item.istatComune] = {
                            color: item.colors && item.colors.length > 0 ? item.colors[0] : '#cccccc',
                            percentuale: item.percLista,
                            candidato: item.descrizioneLista,
                            candidatoId: item.idVincente || item.descrizioneLista, 
                            lista: item.descrizioneLista, 
                            listaId: item.idVincente || item.descrizioneLista,
                            sezioni:item.sezioni
                        };
                    });
            }
            if (Object.keys(transformedData).length === 0) {
                resetToInitialState();
                return;
            }
            
            processWinnerMapData({
                data: transformedData,
                isWinnerMap: winnerMapData.isWinnerMap,
                type: winnerMapData.type,
                title: winnerMapData.title
            });
        });
    } else {
        // Use provided data
        processWinnerMapData(winnerMapData);
    }
}

function processWinnerMapData(winnerMapData) {
    if (!winnerMapData.data || Object.keys(winnerMapData.data).length === 0) {
        resetToInitialState();
        return;
    }
    Object.keys(comuniList).forEach(istatCode => {
        const comune = comuniList[istatCode];
        comune.setStyle(getDefaultStyle());
        comune.values_.value = 'N.D.';
        comune.values_.sezioni = '';
    });
    
    // Apply winner colors and data to municipalities
    Object.keys(winnerMapData.data).forEach(istatCode => {
        const comune = comuniList[istatCode];
        if (comune) {
            const winnerData = winnerMapData.data[istatCode];
            const style = new Style({
                fill: new Fill({
                    color: winnerData.color
                }),
                stroke: new Stroke({
                    color: '#ffffff',
                    width: 1
                })
            });
            comune.setStyle(style);
            
            if (winnerMapData.type === 'candidate') {
                comune.values_.value = `${winnerData.candidato} (${winnerData.percentuale}%)`;
            } else {
                comune.values_.value = `${winnerData.lista} (${winnerData.percentuale}%)`;
            }
            comune.values_.sezioni = `${winnerData.sezioni || ''}`;
        }
    });
    createWinnerMapLegend(winnerMapData);
    
    document.getElementById('loader_overlay').style.display = 'none';
}

function createWinnerMapLegend(winnerMapData) {
    if (!winnerMapData.data || Object.keys(winnerMapData.data).length === 0) {
        ColorLegendItem.hide();
        return;
    }
    const uniqueWinners = {};
    Object.values(winnerMapData.data).forEach(data => {
        const key = winnerMapData.type === 'candidate' ? data.candidatoId : data.listaId;
        const name = winnerMapData.type === 'candidate' ? data.candidato : data.lista;
        if (!uniqueWinners[key]) {
            uniqueWinners[key] = {
                name: name,
                color: data.color
            };
        }
    });
    
    const colors = Object.values(uniqueWinners).map(w => w.color);
    const labels = Object.values(uniqueWinners).map(w => w.name);
    
    ColorLegendItem.setColors(colors);
    ColorLegendItem.setSteps(labels);
    ColorLegendItem.draw();
    ColorLegendItem.show(); // Show legend when data is loaded
}

function loadData() {
    const dataUrl = getDataUrl();
    if (!dataUrl) {
        alert('Selezionare almeno una lista o un candidato.');
        return;
    }
    if (dataUrl.isWinnerMap) {
        loadWinnerMapData(dataUrl);
        return;
    }
    const selectedListaConfronto = document.getElementById('select-lista-confronto').value;
    const selectedCandidato = document.getElementById('select-candidato').value;
    const selectedLista = document.getElementById('select-lista').value;

    document.getElementById('loader_overlay').style.display = 'block';
    getData(dataUrl.url || dataUrl, (res) => {
        const resetComuni = (value = '0.0') => {
        Object.values(comuniList).forEach(feature => {
            feature.setStyle(getDefaultStyle());
            feature.values_.value = value;
            feature.values_.sezioni = '';
        });
        };

        // --- Process normal data (non-confronto)
        if (selectedCandidato || selectedLista) {
            res.dati = res.dati
                .filter(item => !!item.istatComune)
                .map(item => {
                    year2020Data[item.istatComune] = item.percLista;
                    return item;
                });

            const numberArray = res.dati.map(item => item.percLista);
            const steps = getStepsFromGeoStats(numberArray, 5).map(num => num.toFixed(1));
            const colors = colorPalette;

            ColorLegendItem.setColors(colors);
            ColorLegendItem.setSteps(steps);
            ColorLegendItem.draw();
            ColorLegendItem.show(); // Show legend when data is loaded

            // Reset comuni before applying colors
            resetComuni();

            // Apply colors based on percLista
            res.dati.forEach(comune => {
                const feature = comuniList[comune.istatComune];
                if (!feature) return;
                feature.setStyle(getStyle(comune.percLista, colors, steps));
                feature.values_.value = formatPercValue(comune.percLista);
                feature.values_.sezioni = comune.sezioni || '';
            });

            comuniLayer.setOpacity(1);
        }

        if (selectedListaConfronto) {
            resetComuni('N.D.');
            const selectedRadio = document.querySelector('input[name="select-year"]:checked');
            if (!selectedRadio) {
                alert('Seleziona un tipo di confronto.');
                loader.style.display = 'none';
                return;
            }

            const type = selectedRadio.value;
            const propertyToUse = type === 'variazione-voti-2020' ? 'votiListaIndice' : 'percListaIndice';
            const legendColors = ['#ff0000', '#ff6666', '#ffffff', '#90ee90', '#008000'];
            const legendSteps = ['< 85%', '< 100%', '= 100%', '> 100%', '> 115%'];

        res.dati.forEach(item => {
            const feature = comuniList[item.istatComune];
            if (!feature) return;

            let val = Number(item[propertyToUse]);
            let color = '#cccccc';
                if (!isNaN(val)) {
                    if (val < 85) color = '#ff0000';
                 else if (val < 100) color = '#ff6666';
                 else if (val === 100) color = '#ffffff';
                 else if (val > 115) color = '#008000';
                 else color = '#90ee90';
            }

            feature.setStyle(new Style({
                fill: new Fill({color: color }),
                stroke: new Stroke({ color: '#ffffff', width: 1 })
            }));

            feature.values_.value = isNaN(val) ? 'N.D.' : val + '%';
            feature.values_.descrizioneLista = item.descrizioneLista || '';
            feature.values_.sezioni = item.sezioni || '';
        });

        ColorLegendItem.setColors(legendColors);
        ColorLegendItem.setSteps(legendSteps);
        ColorLegendItem.draw();
        ColorLegendItem.show(); // Show legend when data is loaded
        confrontoExplanation.hidden = false;
        comuniLayer.setOpacity(1);
        }
        document.getElementById('loader_overlay').style.display = 'none';
    });
}

const formatPercValue = (n) => {
    if (isNaN(n)) {
        if (String(n) === 'NaN') {
            return 'N.D.';
        }
        return String(n);
    }
    return Number(n).toFixed(1) + '%';
};

const calculatePercDiff = (current, previous) => {
    current = isNaN(current) ? 0 : +current;
    previous = isNaN(previous) ? 0 : +previous;
    return (current - previous).toFixed(2);
}

const populateSelect = (selectId, options) => {
    const selectRef = document.getElementById(selectId);
    if (!selectRef) {
        return;
    }
    selectRef.innerHTML = '<option value="">Seleziona...</option>';
    for (const option of options) {
        const optionRef = document.createElement('option');
        optionRef.value = option.id;
        optionRef.innerText = option.nome;
        selectRef.appendChild(optionRef);
    }
}

const activateSelect = (selectId) => {
    const selectRef = document.getElementById(selectId);
    selectRef.addEventListener('change', (e) => {
        if (e.target["value"] === '') {
            return;
        }
        // Close any open popup when changing selection
        destroyOverlay();
        /// Reset all form controls
        const allSelect = document.querySelectorAll('select');
        Array.prototype.forEach.call(allSelect, function (itemRef) {
            if (itemRef !== selectRef) {
                itemRef.value = '';
            }
        });
        // Clear winner map radio buttons when selecting candidate/list
        document.getElementById('candidatiPresidenteVincenti').checked = false;
        document.getElementById('listeVincentiComuni').checked = false;
        loadData();
    });
}
let candidati = [];
const populateCandidatiSelect = () => {
    getData(mapConfig.basePath + 'candidati.json', (candidatiResponse) => {
        candidati = candidatiResponse;
        populateSelect('select-candidato', candidatiResponse);
    })
}
let liste = [];
const populateListeSelect = () => {
    getData(mapConfig.basePath + 'liste.json', (listeResponse) => {
        liste = listeResponse;
        populateSelect('select-lista', listeResponse);
    })

}

let listeConfronto = [];
const populateListeConfrontoSelect = () => {
    getData(mapConfig.basePath + 'listeconfronto.json', (listeResponse) => {
        listeConfronto = listeResponse;
        populateSelect('select-lista-confronto', listeResponse);
    });
}

const activateRefreshButton = () => {
    const refreshButton = document.getElementById('filter-refresh-generali');
    refreshButton.addEventListener('click', () => {
        resetMapaGenerali();
        resetToInitialState();
    });

    const refreshButtonPercentuali = document.getElementById('filter-refresh-percentuali');
    refreshButtonPercentuali.addEventListener('click', () => {
        resetMapaPercentuali();
        resetToInitialState();
    });
    const refreshButtonConfronto = document.getElementById('filter-refresh-confronto');
    refreshButtonConfronto.addEventListener('click', () => {
        resetMapaConfronto();
        confrontoExplanation.hidden = true;
        resetToInitialState();
      
    });
}

const resetMapaGenerali = () => {
    document.getElementById('candidatiPresidenteVincenti').checked = false;
    document.getElementById('listeVincentiComuni').checked = false;
}

const resetMapaPercentuali = () => {
    document.getElementById('select-candidato').value = '';
    document.getElementById('select-lista').value = '';
}

const resetMapaConfronto = () => {   
       document.getElementById('select-lista-confronto').value = '';
    document.querySelectorAll('input[name="select-year"]').forEach(radio => {
        radio.checked = false;
        radio.disabled = true;
    });
  

}


const resetToInitialState = () => {
    destroyOverlay();
    // Reset map title to initial state
    document.getElementById('map-title').textContent = 'Mappa cromatica';
    
    // Reset all municipalities to default style (same as page load)
    Object.keys(comuniList).forEach(istatCode => {
        const comune = comuniList[istatCode];
        comune.setStyle(getDefaultStyle());
        comune.values_.value = 'N.D.';
        comune.values_.sezioni = '';
    });
    
    // Hide legend when no selection is active
    ColorLegendItem.hide();
    
    // Hide loader (same as page load)
    document.getElementById('loader_overlay').style.display = 'none';
    
    // Reset map opacity
    comuniLayer.setOpacity(1);
}

const activateCandidatiSelect = () => {
    activateSelect('select-candidato');
}

const activateListaSelect = () => {
    activateSelect('select-lista');
}

const activateListaConfrontoSelect = () => {
    activateSelect('select-lista-confronto');
}

const activateRadioChange = () => {
    const allRadio = document.querySelectorAll('input[type="radio"]');
    Array.prototype.forEach.call(allRadio, (radio) => {
        radio.addEventListener('change', () => {
            // Close any open popup when changing radio selection
            destroyOverlay();
            // Clear selections when switching to winner maps
            if (radio.name === 'map-type') {
                clearSelections();
            }
            loadData();
        })
    });
}

const clearSelections = () => {
    document.getElementById('select-candidato').value = '';
    document.getElementById('select-lista').value = '';
    document.getElementById('select-lista-confronto').value = '';

    toggleConfrontoRadios();

}

const toggleConfrontoRadios = () => {
    const hasValue =   document.getElementById('select-lista-confronto').value.trim() !== '';
    const confrontoRadios = document.querySelectorAll('.filter-column .card:nth-child(3) input[type="radio"]');
    confrontoRadios.forEach(radio => {
      radio.disabled = !hasValue;
      // Optionally, uncheck if disabling
      if (!hasValue) radio.checked = false;
    });
  };

const activateColumnToggler = () => {
    const column = document.querySelector('.filter-column');
    document.getElementById('column-toggle').addEventListener('click', () => {
        destroyOverlay();
        column.classList.toggle('open');
    })
}

const isSmallScreen = () => {
    return document.body.clientWidth <= 992;
}

const checkConfrontoVisibility = () => {
    getData(mapConfig.resourcesPath + mapConfig.mappaProduction + 'property.json', (propertyResponse) => {
        const confrontoSection = document.getElementById('mappaConfronto');
        if (propertyResponse && propertyResponse.mappaConfronto === true) {
            confrontoSection.style.display = 'block';
        } else {
            confrontoSection.style.display = 'none';
        }
    });
}


const getDataUrl = () => {
    const selectedCandidato = document.getElementById('select-candidato').value;
    const selectedLista = document.getElementById('select-lista').value;
    const candidatiPresidenteVincenti = document.getElementById('candidatiPresidenteVincenti').checked;
    const listeVincenti = document.getElementById('listeVincentiComuni').checked;
    const selectedListaConfronto = document.getElementById('select-lista-confronto').value;
    
    let dataObject;
    if (!!selectedCandidato) {
        dataObject = candidati.filter(item => item.id === selectedCandidato)[0];
    } else if (!!selectedLista) {
        dataObject = liste.filter(item => item.id === selectedLista)[0];
    }
    else if(!!selectedListaConfronto) {
        dataObject = listeConfronto.filter(item => item.id === selectedListaConfronto)[0];
    }

    if (!dataObject && !candidatiPresidenteVincenti && !listeVincenti) {
        alert('Non esiste un set di dati da caricare per la selezione');
        return false;
    }
    if(!!selectedListaConfronto) {
        /// Disabilita i pulsanti radio per i set di dati non disponibili
        const elezioniRadioVariazioneAbsoluta2020 = document.getElementById('select-variazione-%-2020');
        elezioniRadioVariazioneAbsoluta2020.disabled = !dataObject.files.year2025;
        const elezioniRadioVariazioneVoti2020 = document.getElementById('select-variazione-voti-2020');
        elezioniRadioVariazioneVoti2020.disabled = !dataObject.files.year2025;
    }
    if (candidatiPresidenteVincenti || listeVincenti) {
    colorPalette = ["#cde4c2", "#b0dc9b", "#93d574", "#76cd4d", "#59c627"];
    } else if (Array.isArray(dataObject?.colors)) {
    if (dataObject.colors.length === 5) {
        colorPalette = dataObject.colors;
    } else {
        colorPalette = getColorGradient(dataObject.colors[0], dataObject.colors[dataObject.colors.length - 1], 5);
    }
    } else {
    colorPalette = getColorGradient("#420D52", "#F6E124", 5);
    }
    let selectedElezione;
    if(selectedCandidato || selectedLista) {
        selectedElezione = 'year2025';
    }
    else if(candidatiPresidenteVincenti) {
        selectedElezione = 'candidatiPresidenteVincenti';
    }
    else if(listeVincenti) {
        selectedElezione = 'listeVincentiComuni';
    }
    else if(selectedListaConfronto) {
        const checkedRadio = document.querySelector('input[name="select-year"]:checked');
            if (checkedRadio) {
              selectedElezione = checkedRadio.value;
            } else {
              const defaultRadio = document.getElementById("select-variazione-%-2020");
               selectedElezione =  defaultRadio.value;
              if (defaultRadio) defaultRadio.checked = true;
            }
    }
    else {
        const checkedRadio = document.querySelector('input[type="radio"]:checked');
        selectedElezione = checkedRadio ? checkedRadio.value : null;
    }
        
    if(selectedCandidato || selectedLista) {
        if (!dataObject?.files[selectedElezione]) {
            alert('Non esiste un set di dati da caricare per questa elezione');
            return false;
        }
    }
    /// Modifica il titolo
    const mapTitleRef = document.getElementById('map-title');
    let urlDati;
    switch (selectedElezione) {
      case "variazione-%-2020":
        mapTitleRef.innerText = `${dataObject.nome}: variazione relativa rispetto al 2020 (%).`;
        urlDati = mapConfig.resourcesPath + mapConfig.mappaProduction +'datiStorici/' + dataObject.files["year2025"];
        break;
      case "variazione-voti-2020":
        mapTitleRef.innerText = `${dataObject.nome}: variazione relativa rispetto al 2020 (val. assoluti).`;
        urlDati = mapConfig.resourcesPath + mapConfig.mappaProduction +'datiStorici/' + dataObject.files["year2025"];
        break;
        case "year2025":
            mapTitleRef.innerText = `${dataObject.nome}: risultati regionali 2025.`;
            urlDati = mapConfig.resourcesPath +mapConfig.mappaProduction  + dataObject.files[selectedElezione];
          break;
        case "candidatiPresidenteVincenti":
            mapTitleRef.innerText = `Candidati Presidente vincente nei Comuni: risultati regionali 2025.`;
            urlDati = {
          url: mapConfig.resourcesPath + mapConfig.mappaProduction  +"candidativincenti.json",
          isWinnerMap: true,
          type: "candidate",
          title: "Candidati Presidente vincente nei Comuni: risultati regionali 2025.",
        };
        break;
            case "listeVincentiComuni":
            mapTitleRef.innerText = `Liste vincenti nei Comuni: risultati regionali 2025.`;
            urlDati = {
          url: mapConfig.resourcesPath + mapConfig.mappaProduction  + "listevincenti.json",
          isWinnerMap: true,
          type: "list",
          title: "Liste vincenti nei Comuni: risultati regionali 2025.",
        };
        break;
    }


    return urlDati;
}


document.querySelectorAll('input[name="map-type"]').forEach(radio => {
  radio.addEventListener('change', () => {
    confrontoExplanation.hidden = true;
  });
});

let datiRegionali = {};
// legge il json con i dati aggregati regionali e popola il box relativo
const populateDatiRegionali = () => {
    getData(mapConfig.resourcesPath + mapConfig.datiRegionali + 'S_050000000000.json', (datiRegionaliResponse) => {
        datiRegionali = datiRegionaliResponse;
        const divSezCons = document.getElementById('sez_cons');
        divSezCons.innerText = datiRegionali.int.sz_cons + ' sez. liste su ' + datiRegionali.int.sz_tot;

        const divSezConsPerc = document.getElementById('sez_cons_perc');
        divSezConsPerc.innerText = (datiRegionali.int.sz_cons * 100 / datiRegionali.int.sz_tot).toFixed(2) + '%';

        const divSezPres = document.getElementById('sez_pres');
        divSezPres.innerText = datiRegionali.int.sz_pres + ' sez. cand su ' + datiRegionali.int.sz_tot;

        const divSezPresPerc = document.getElementById('sez_pres_perc');
        divSezPresPerc.innerText = (datiRegionali.int.sz_pres * 100 / datiRegionali.int.sz_tot).toFixed(2) + '%';

        const divElettori = document.getElementById('elettori');
        divElettori.innerText = datiRegionali.int.ele_t.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        const divVotanti = document.getElementById('votanti');
        divVotanti.innerText = datiRegionali.int.vot_t.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");

        const divVoti = document.getElementById('voti');
        divVoti.innerText = datiRegionali.int.tot_vot_cand.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    })
}

window.onload = function () {
    /// Popola la select dei candidati
    populateCandidatiSelect();
    /// Popola la select delle liste
    populateListeSelect();
    ///Popola la select delle liste confronto
    populateListeConfrontoSelect();
    /// Check property.json to show/hide confronto section
    checkConfrontoVisibility();
    /// Attiva il pulsante Aggiorna
    activateRefreshButton();
    /// Attiva la select dei candidati
    activateCandidatiSelect();
    /// Attiva la select delle liste
    activateListaSelect();
    /// Attiva la select delle liste confronto
    activateListaConfrontoSelect();
    /// Attiva il change dei radio
    activateRadioChange();
    /// Attiva il menu toggler
    activateColumnToggler();
    // la sezione con i dati degli scrutini
    populateDatiRegionali();
    /// Nasconde il loader
    document.getElementById('loader_overlay').style.display = 'none';
    /// Hide legend initially since no selection is made
    ColorLegendItem.hide();
}

// per un bug sulla libreria su IE11 che spacca su document.contains()
document.contains = document.contains || function (el) {
    return document.body.contains(el);
}
